import { React, useCallback, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "./index.scss";

import successTick from "../../../../assets/images/common/Success.gif";
import failed from "../../../../assets/images/common/failed.gif";


import Button from "../../../ui/Button";
import DropDown from '../../../ui/DropDown';
import RadioButton from "../../../ui/RadioButton";

import { getloggedInUserType } from "../../../../utils/util.js";

import { useSelector, useDispatch } from 'react-redux';
import { assignAndUnAssign, getDomainList, getUsersList, getDomainListByOrganization, getUsersListByOrganization } from '../../../../store/actions/organizationActions';

import apiEndpoints from "../../../../apiEndpoints.js";

const ModifyDomain = ({selectedTab, clsoeModifyModal, customerDetails="", organizationDetail="", currentPageType}) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { organizationId, customerId } = useParams();

    const usersListResponse = useSelector((state) => state.organization?.usersList);
    const domainListResponse = useSelector((state) => state.organization?.domainList);
    const assignedDomainListResponse = useSelector((state) => state.organization?.assignedDomainListByOrganization);
    const assignedUserListResponse = useSelector((state) => state?.organization?.assignedUserListByOrganization)
    const assignUnAssignResponse = useSelector((state) => state.organization?.assignUnAssignResponse)

    const [responseStatus, setResponseStatus] = useState(false);

    const [activeTab, setActiveTab] = useState('assign');

    const [selectedUser, setSelectedUser] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [assignedUsersList, setAssignedUsersList] = useState([]);
    const [userSearchValue, setUserSearchValue] = useState("");
    const [userSearchLoading, setUserSearchLoading] = useState(false);
    const [userCurrentPage, setUserCurrentPage] = useState(1);
    const [userPageLoading, setUserPageLoading] = useState(false);
    const [userTotalPage, setUserTotalPage] = useState(0);

    const [assignedUserSearch, setAssignedUserSearch] = useState("");
    const [assignedUserSearchLoading, setAssignedUserSearchLoading] = useState(false);
    const [assignedUserCurrentPage, setAssignedUserCurrentPage] = useState(1);
    const [assignedUserPageLoading, setAssignedUserPageLoading] = useState(false);
    const [assignedUserTotalPage, setAssignedUserTotalPage] = useState(0);

    const [domainList, setDomainList] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState([]);
    const [domainSearchValue, setDomainSearchValue] = useState("");
    const [domainSearchLoading, setDomainSearchLoading] = useState(false);
    const [domainCurrentPage, setDomainCurrentPage] = useState(1);
    const [domainPageLoading, setDomainPageLoading] = useState(false);
    const [domainTotalPage, setDomainTotalPage] = useState(0);

    const [assignedDomainSearch, setAssignedDomainSearch] = useState("");
    const [assignedDomainSearchLoading, setAssignedDomainSearchLoading] = useState(false);
    const [assignedDomainList, setAssignedDomainList] = useState([])
    const [assignedDomainCurrentPage, setAssignedDomainCurrentPage] = useState(1);
    const [assignedDomainPageLoading, setAssignedDomainPageLoading] = useState(false);
    const [assignedDomainTotalPage, setAssignedDomainTotalPage] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const [resetAssignUserSelectedList, setResetAssignUserSelectedList] = useState(false);
    const [resetUnAssignUserSelectedList, setResetUnAssignUserSelectedList] = useState(false);
    const [resetAssignDomainSelectedList, setResetAssignDomainSelectedList] = useState(false);
    const [resetUnAssignDomainSelectedList, setResetUnAssignDomainSelectedList] = useState(false);

    const [activeScan, setActiveScan] = useState("");
    const [passiveScan, setPassiveScan] = useState("");
    const [domainType, setDomainType] = useState("");

    
    const goBack = () => {
        setResponseStatus(false);
        setIsLoading(false);
        clsoeModifyModal();
        setActiveScan("");
        setPassiveScan("");
        setDomainType("");
    }

    const changeDomainType = (value) => {
        if(value === "internal" || value === "portfolio") {
            setActiveScan("yes");
            setPassiveScan("yes");
        } else {
            setActiveScan("no");
            setPassiveScan("yes");
        }
        setDomainType(value)
    }

    const handleSelectUser = (value) => {
        setSelectedUser(value)
    }

    const handleSelectDomain = (value) => {
        setSelectedDomain(value)
    }

    const fetchDomainList = useCallback(()=>{
        if(getloggedInUserType() === "internal" && currentPageType === "organizationDetails" && customerId) {
            const baseUrl = `&customer_id=${customerId}&page=${domainCurrentPage}&page_size=10`;
            const queryParams = domainSearchValue ? `&query=${domainSearchValue}` : "";
            const domainType = organizationDetail?.type ? `&domainType=${organizationDetail?.type}` : "";
            const url = `${baseUrl}${domainType}${queryParams}`
            dispatch(getDomainList(url));
        } else {
            const baseUrl = `&page=${domainCurrentPage}&page_size=10`
            const queryParams = domainSearchValue ? `&query=${domainSearchValue}` : "";
            const domainType = organizationDetail?.type ? `&domainType=${organizationDetail?.type}` : "";
            const url = `${baseUrl}${domainType}${queryParams}`
            dispatch(getDomainList(url));
        }
    },[domainSearchValue, dispatch, currentPageType, customerId, domainCurrentPage, organizationDetail])
    
    const fetchAssignedDomainList = useCallback(()=>{        
        if(currentPageType === "organizationDetails") {
            const baseUrl = `&page=${assignedDomainCurrentPage}&page_size=10&organization_id=${organizationDetail?.organization_id}`;
            const queryParams = assignedDomainSearch ? `&query=${assignedDomainSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getDomainListByOrganization(url, "modify"));
        } else {
            const baseUrl = `&page=${assignedDomainCurrentPage}&page_size=10&customer_id=${customerDetails?.customer_id}`;
            const queryParams = assignedDomainSearch ? `&query=${assignedDomainSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getDomainListByOrganization(url, "modify"));
        }
    },[dispatch, organizationDetail, customerDetails, assignedDomainSearch, currentPageType, assignedDomainCurrentPage])

    const fetchUsersList = useCallback(()=>{
        if(getloggedInUserType() === "internal" && currentPageType === "organizationDetails" && customerId) {
            const baseUrl = `&customer_id=${customerId}&page=${userCurrentPage}&page_size=10`
            const queryParams = userSearchValue ? `&query=${userSearchValue}` : "";
            const url = `${baseUrl}${queryParams}`
            dispatch(getUsersList(url));
        } else {
            const baseUrl = `&page=${userCurrentPage}&page_size=10`;
            const queryParams = userSearchValue ? `&query=${userSearchValue}` : "";
            const url = `${baseUrl}${queryParams}`
            dispatch(getUsersList(url))
        }     
    },[dispatch, userSearchValue, currentPageType, customerId, userCurrentPage])

    const fetchAssignedUserList = useCallback(()=>{        
        if(currentPageType === "organizationDetails") {
            const baseUrl = `&page=${assignedUserCurrentPage}&page_size=10&organization_id=${organizationDetail?.organization_id}`;
            const queryParams = assignedUserSearch ? `&query=${assignedUserSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getUsersListByOrganization(url, "modify"));
        } else {
            const baseUrl = `&page=${assignedUserCurrentPage}&page_size=10&customer_id=${customerDetails?.customer_id}`;
            const queryParams = assignedUserSearch ? `&query=${assignedUserSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getUsersListByOrganization(url, "modify"));
        }
        
    },[dispatch, organizationDetail, customerDetails, currentPageType, assignedUserSearch, assignedUserCurrentPage])

    const changeTab = (value) => {
        if(selectedTab === "domain") {
            setSelectedDomain([])
            if(value === "assign") {
                setResetAssignUserSelectedList(false)
                setResetUnAssignUserSelectedList(true)
            } else {
                setResetAssignUserSelectedList(true)
                setResetUnAssignUserSelectedList(false)
            }
        }

        if(selectedTab === "users") {
            setSelectedUser([])
            if(value === "assign") {
                setResetAssignDomainSelectedList(false)
                setResetUnAssignDomainSelectedList(true)
            } else {
                setResetAssignDomainSelectedList(true)
                setResetUnAssignDomainSelectedList(false)
            }
        }
        setActiveTab(value)
    }

    const saveList = () => {
        const ids = selectedTab === "domain" ? selectedDomain.map(data => data.name) : selectedUser.map(data => data.id);
        const isDomain = selectedTab === "domain";
        const isAssign = activeTab === "assign";
        
        const obj = {
            organization_id: organizationId,
            ...(isDomain ? { domains: ids } : { user_ids: ids })
        };
    
        const url = isDomain
            ? (isAssign ? apiEndpoints.domains.assignDomain() : apiEndpoints.domains.unAssignDomain())
            : (isAssign ? apiEndpoints.users.assignUser() : apiEndpoints.users.unAssignUser());
            setIsLoading(true)
        dispatch(assignAndUnAssign(url, obj));
    };

    const internalSaveList = () => {
        const ids = selectedTab === "domain" ? selectedDomain.map(data => data.name) : selectedUser.map(data => data.id);
        const isDomain = selectedTab === "domain";
        const isAssign = activeTab === "assign";

        if(currentPageType === "customerDetails") {
            let obj = {
                customer_id: customerDetails !== "" ? customerDetails.customer_id : customerId,        
                ...(isDomain ? { domains: ids } : { user_ids: ids })
            };
    
            if(isDomain && isAssign) {
                obj.passive_scan = passiveScan === "yes" ? true : false
                obj.active_scan = activeScan === "yes" ? true : false
                obj.domain_type = domainType
            }
    
            const url = isDomain
                ? (isAssign ? apiEndpoints.customer.assignDomainToCustomer() : apiEndpoints.customer.unAssignDomainToCustomer())
                : (isAssign ? apiEndpoints.customer.assignUsersToCustomer() : apiEndpoints.customer.unAssignUsersToCustomer());
                setIsLoading(true)
            dispatch(assignAndUnAssign(url, obj));
        } else if (currentPageType === "organizationDetails") {

            const obj = {
                organization_id: organizationId,
                ...(isDomain ? { domains: ids } : { user_ids: ids })
            };

            const url = isDomain
            ? (isAssign ? apiEndpoints.customer.assignDomainToOrganization() : apiEndpoints.customer.unAssignDomainToOrganization())
            : (isAssign ? apiEndpoints.customer.assignUserToOrganization() : apiEndpoints.customer.unAssignUserToOrganization());
            setIsLoading(true)
            dispatch(assignAndUnAssign(url, obj));
        }
    }

    useEffect(()=>{
        fetchDomainList()
    },[domainSearchValue, fetchDomainList])

    useEffect(()=>{
        fetchAssignedDomainList()
    },[fetchAssignedDomainList, assignedDomainSearch])

    useEffect(()=>{
        fetchUsersList()
    },[userSearchValue, fetchUsersList])

    useEffect(()=>{
        fetchAssignedUserList()
    },[fetchAssignedUserList, assignedUserSearch])

    useEffect(()=>{        
        if(usersListResponse != null){
            setUserSearchLoading(false)
            setUserPageLoading(false)
            let newList = usersListResponse?.results.map((data)=>{
                return {
                    id: data.user_id,
                    firstName: data.firstname,
                    lastName: data.lastname,
                    value: data.user_id,
                    email: data.email,
                    avatar: data.avatar,
                    label: data.firstname + " " + data.lastname
                }
            })
            setUsersList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setUserTotalPage(usersListResponse?.meta?.total_pages)
        }
    },[usersListResponse])

    useEffect(()=>{        
        if(assignedUserListResponse !== null){
            setAssignedUserSearchLoading(false)
            setAssignedUserPageLoading(false)
            let newList = assignedUserListResponse?.results.map((data)=>{
                return {
                    id: data.user_id,
                    firstName: data.firstname,
                    lastName: data.lastname,
                    value: data.user_id,
                    email: data.email,
                    logo: data.avatar,
                    label: data.firstname + " " + data.lastname
                }
            })
            setAssignedUsersList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setAssignedUserTotalPage(assignedUserListResponse?.meta?.total_pages)
        }
    },[assignedUserListResponse])
    

    useEffect(()=>{
        if(domainListResponse != null) {
            setDomainSearchLoading(false)
            setDomainPageLoading(false)
            let newList = domainListResponse?.results.map((data)=>{
                return {
                    id: data.domain_id,
                    name: data.domain,
                    value: data.domain_id,
                    logo: data.logo,
                    label: data.domain
                }
            })
            setDomainList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setDomainTotalPage(domainListResponse?.meta?.total_pages)
        }
    },[domainListResponse])

    useEffect(()=>{
        if(assignedDomainListResponse != null) {
            setAssignedDomainSearchLoading(false)
            setAssignedDomainPageLoading(false)
            let newList = assignedDomainListResponse?.results.map((data)=>{
                return {
                    id: data.domain_id,
                    name: data.domain,
                    value: data.domain_id,
                    logo: data.logo,
                    label: data.domain
                }
            })
            setAssignedDomainList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setAssignedDomainTotalPage(assignedDomainListResponse?.meta?.total_pages)
        }
    },[assignedDomainListResponse])

    useEffect(()=>{
        if(assignUnAssignResponse !== null ) {
            setIsLoading(false)
            setResponseStatus(true)
        } else {
            setIsLoading(false);
            setResponseStatus(false)
        }
    },[assignUnAssignResponse])


    return (
        <div className="add-organization-container add-domain-container">
            {!responseStatus && <>
                <div className="modal-header mt-4">
                    {selectedTab === "domain" ? <h2>{t('organizationDetailsPage.modify.modifyDomain')}</h2> : <h2>{t('organizationDetailsPage.modify.modifyUsers')}</h2>}
                </div>
                <div className="assign-tab-container d-flex rounded my-3">
                    <p className={`rounded text-center ${activeTab === "assign" ? "active" : ""}`} onClick={()=>changeTab('assign')}>{t('organizationDetailsPage.modify.assign')}</p>
                    <p className={`rounded text-center ${activeTab === "unAssign" ? "active" : ""}`} onClick={()=>changeTab("unAssign")}>{t('organizationDetailsPage.modify.unAssign')}</p>
                </div>
                <div className="add-organization-step-one mb-5">
                    {selectedTab === "users" && activeTab === "assign" && 
                        <DropDown
                            options={usersList}
                            placeHolder='Please select User'
                            dropDownType={"modifyUser"}
                            onChange={(e) => handleSelectUser(e)}
                            isSearchable = {true}
                            resetValue={resetAssignUserSelectedList}
                            isMulti
                            searchType={"server"}
                            defaultSelectedValue={selectedUser}
                            updateSearchValue={(data)=>{
                                setUsersList([])
                                setUserSearchLoading(true)
                                setUserSearchValue(data)
                                setUserCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                            }}                            
                            isSearchLoading={userSearchLoading}
                            onScrollEnd = {()=>{
                                if(!userPageLoading && (userTotalPage > userCurrentPage)) {
                                    setUserPageLoading(true)
                                    setUserCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={userPageLoading}
                        />
                    }
                    {selectedTab === "users" && activeTab === "unAssign" && 
                        <DropDown
                            options={assignedUsersList}
                            placeHolder='Please select User'
                            dropDownType={"modifyUser"}
                            onChange={(e) => handleSelectUser(e)}
                            isSearchable = {true}
                            resetValue={resetUnAssignUserSelectedList}
                            isMulti
                            searchType={"server"}
                            defaultSelectedValue={selectedUser}
                            updateSearchValue={(data)=>{
                                setAssignedUsersList([])
                                setAssignedUserSearchLoading(true)
                                setAssignedUserSearch(data)
                                setAssignedUserCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                            }}                            
                            isSearchLoading={assignedUserSearchLoading}
                            onScrollEnd = {()=>{
                                if(!assignedUserPageLoading && (assignedUserTotalPage > assignedUserCurrentPage)) {
                                    setAssignedUserPageLoading(true)
                                    setAssignedUserCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={assignedUserPageLoading}
                        />
                    }
                    {selectedTab === "domain" && activeTab === "assign" && 
                        <DropDown
                            options={domainList}
                            placeHolder='Please select Domain'
                            dropDownType={"modifyDomain"}
                            onChange={(e) => handleSelectDomain(e)}
                            isSearchable = {true}
                            resetValue={resetAssignDomainSelectedList}
                            isMulti
                            searchType={"server"}
                            defaultSelectedValue={selectedDomain}
                            updateSearchValue={(data)=>{
                                setDomainList([])
                                setDomainSearchLoading(true)
                                setDomainSearchValue(data)
                                setDomainCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                            }}                            
                            isSearchLoading={domainSearchLoading}
                            onScrollEnd = {()=>{
                                if(!domainPageLoading && (domainTotalPage > domainCurrentPage)) {
                                    setDomainPageLoading(true)
                                    setDomainCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={domainPageLoading}
                        />
                    }
                    {selectedTab === "domain" && activeTab === "unAssign" && 
                        <DropDown
                            options={assignedDomainList}
                            placeHolder='Please select Domain'
                            dropDownType={"modifyDomain"}
                            onChange={(e) => handleSelectDomain(e)}
                            isSearchable = {true}
                            resetValue={resetUnAssignDomainSelectedList}
                            isMulti
                            searchType={"server"}                            
                            defaultSelectedValue={selectedDomain}
                            updateSearchValue={(data)=>{
                                setAssignedDomainList([])
                                setAssignedDomainSearchLoading(true)
                                setAssignedDomainSearch(data)
                                setAssignedDomainCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage));
                            }}
                            isSearchLoading={assignedDomainSearchLoading}
                            onScrollEnd = {()=>{
                                if(!assignedDomainPageLoading && (assignedDomainTotalPage > assignedDomainCurrentPage)) {
                                    setAssignedDomainPageLoading(true)
                                    setAssignedDomainCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={assignedDomainPageLoading}
                        />
                    }
                    {getloggedInUserType() === "internal" && selectedTab === "domain" && activeTab === "assign"  && currentPageType === "customerDetails" &&
                        <>
                            {domainType === "third_party" && activeScan === "yes" && <div className="warning-msg p-0 mt-3">
                                <p className="msg-text">{t('organizationDetailsPage.modify.warningMessage')}</p>
                            </div>}
                            <div className="organization-type mt-4">
                                <p>{t('organizationDetailsPage.modify.domainType')}</p>
                                <div className="radio-btn-group d-flex mt-3">
                                    <RadioButton radioId={'internal'} radioLabel={'Internal'} radioValue={'internal'} onChange={(value)=>{changeDomainType(value)}}  isChecked={domainType === 'internal'}/>
                                    <RadioButton radioId={'portfolio'} radioLabel={'Portfolio'} radioValue={'portfolio'} onChange={(value)=>{changeDomainType(value)}} isChecked={domainType === 'portfolio'}/>
                                    <RadioButton radioId={'thirdParty'} radioLabel={'Third Party'} radioValue={'third_party'} onChange={(value)=>{changeDomainType(value)}} isChecked={domainType === 'third_party'}/> 
                                </div>
                            </div>
                            <div className="organization-type mt-4">
                                <p>{t('organizationDetailsPage.modify.activeScan')}</p>
                                <div className="radio-btn-group d-flex mt-3">
                                    <RadioButton radioId={'yes1'} radioLabel={'Yes'} radioValue={'yes'} onChange={(value)=>{setActiveScan(value)}}  isChecked={activeScan === 'yes'}/>
                                    <RadioButton radioId={'no1'} radioLabel={'No'} radioValue={'no'} onChange={(value)=>{setActiveScan(value)}} isChecked={activeScan === 'no'}/>
                                </div>
                            </div>
                            <div className="organization-type mt-4">
                                <p>{t('organizationDetailsPage.modify.passiveScan')}</p>
                                <div className="radio-btn-group d-flex mt-3">
                                    <RadioButton radioId={'yes'} radioLabel={'Yes'} radioValue={'yes'} onChange={(value)=>{setPassiveScan(value)}}  isChecked={passiveScan === 'yes'}/>
                                    <RadioButton radioId={'no'} radioLabel={'No'} radioValue={'no'} onChange={(value)=>{setPassiveScan(value)}} isChecked={passiveScan === 'no'}/>
                                </div>
                            </div>                            
                        </>                        
                    }
                </div>
                <div className="form-submit-btn-group mt-4">
                    { getloggedInUserType() === "internal" &&
                        <>
                            <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={()=>{goBack()}}/>
                            {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={()=>{internalSaveList()}} disableButton={selectedTab === "domain" ? selectedDomain.length === 0 : selectedUser.length === 0} />}
                            {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true} />}
                        </>
                    }
                    { getloggedInUserType() === "customer" &&
                        <>
                            <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={()=>{goBack()}}/>
                            {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={()=>{saveList()}} disableButton={selectedTab === "domain" ? selectedDomain.length === 0 : selectedUser.length === 0} />}
                            {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true} />}
                        </>
                    }
                </div>
            </>}
            {responseStatus && <>
                <div className="addOrg-success-container d-flex align-items-center flex-column">
                    {assignUnAssignResponse?.detail?.status === "success" && <>
                        <div className="mt-5">
                            <img src={successTick} alt="success" />
                        </div>
                        <h2 className="mb-4 mt-5">{assignUnAssignResponse?.detail?.description}</h2>
                    </>}
                    {assignUnAssignResponse?.status === "failed" && <div className="addOrg-success-container d-flex align-items-center flex-column">
                            <div className="mt-5">
                                <img src={failed} alt="failed" />
                            </div>
                            <h2 className="mb-4 mt-5 fs-4">{assignUnAssignResponse?.description}</h2>
                            </div>}
                    <div className="btn-container mt-5">
                        <Button buttonText={"Back to Main Page"} buttonType="primary" buttonClicked={()=>{goBack()}} />
                    </div>
                </div>
            </>}
        </div>
    )
}

export default ModifyDomain;